import OriginalCard from './Card.svelte';
import Header from './Header.svelte';
import Content from './Content.svelte';
import OriginalCover from './Cover.svelte';
import Overlay from './Overlay.svelte';
import Footer from './Footer.svelte';
import OriginalActions from './Actions.svelte';
import OriginalAction from './Action.svelte';
import ActionLabel from './ActionLabel.svelte';
import Icon from '../icon/Icon.svelte';
const Card = OriginalCard;
Card.Header = Header;
Card.Content = Content;
Card.Cover = OriginalCover;
Card.Cover.Overlay = Overlay;
Card.Footer = Footer;
Card.Actions = OriginalActions;
Card.Actions.Action = OriginalAction;
Card.Actions.Action.Label = ActionLabel;
Card.Actions.Action.Icon = Icon;
export default Card;
